
export {StompService, StompState} from './src/stomp.service';
export {StompConfig} from './src/stomp.config';



// WEBPACK FOOTER //
// ./~/@stomp/ng2-stompjs/index.ts